// extracted by mini-css-extract-plugin
export var readonly = "_e0-1";
export var star = "_e0-0";